import styled from 'styled-components';

export const GameStatText = styled.span`
  color: ${props => props.theme.colors.white};
  text-transform: uppercase;
  font-size: calc(${props => props.theme.fonts.baseSize} - 2px);
  font-weight: 800;
  margin-bottom: 2px;
  padding-right: 5px;

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    color: ${props => props.theme.colors.tertiary};
    font-size: 10px;
    padding-right: 0;
  }
`;

export const GameStatNumber = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: calc(${props => props.theme.fonts.baseSize} - 2px);
  line-height: 1;

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    color: ${props => props.theme.colors.white};
    font-size: calc(${props => props.theme.fonts.baseSize} + 0.9vmin);
  }
`;

export const GameStatStyled = styled.section`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  min-height: 5vmin;
  padding: 10px 20px 10px 0;

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    background: ${props => props.theme.gameStats.bg};
    border-radius: ${props => props.theme.gameStats.borderRadius};
    box-shadow: ${props => props.theme.gameStats.boxShadow};
    flex-direction: column;
    height: 60px;
    justify-content: center;
    left: ${props => props.theme.gameStats.left};
    margin-bottom: 20px;
    padding: 10px;
    width: 60px;
  }
`;

const GameStatsWrap = styled.section`
  align-items: center;
  display: flex;
  justify-content: center;
  left: 0;
  margin: 0 1vmin;
  opacity: 0;
  padding: 0 ${props => props.theme.blockContainer.paddingLR};
  position: absolute;
  right: 0;
  top: 20px;
  transform: translateX(10px);
  transition: transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut};
  transition-delay: 1s;

  .game-wrap-enter-done & {
    opacity: 1;
    transform: translateX(0);
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    bottom: 5.75vmin;
    flex-direction: column;
    justify-content: flex-start;
    left: -20px;
    padding: 0;
    top: 5.5vmin;
    width: 7vmin;
  }
`;

export default GameStatsWrap;



// WEBPACK FOOTER //
// ./src/components/molecules/GameStats/GameStats.styled.js